import { render, staticRenderFns } from "./WonderTopicTable.vue?vue&type=template&id=3d4c935c&scoped=true"
import script from "./WonderTopicTable.vue?vue&type=script&lang=js"
export * from "./WonderTopicTable.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicTable.vue?vue&type=style&index=0&id=3d4c935c&prod&lang=css"
import style1 from "./WonderTopicTable.vue?vue&type=style&index=1&id=3d4c935c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c935c",
  null
  
)

export default component.exports